/**
 * 协作 WebSocket 的基地址。
 *
 * 协作服务就是本仓后端（`/api/v1/apps/{id}/collaborate`）：本地经 Vite dev proxy、
 * 生产经前端 nginx 的 `/api` 路由反代到 backend 容器，因此默认按当前页面同源推断
 * （https → wss）。绝不回落到 localhost —— 那会指向访问者本机，把线上协作连到
 * 浏览器所在机器上。
 *
 * 仅当部署拓扑上协作服务与前端不同源时，才用构建期 `VITE_WS_URL` 显式覆盖。
 */

type LocationLike = Pick<Location, "protocol" | "host">;

export function resolveWsBaseUrl(
  location: LocationLike = window.location,
  override: string | undefined = import.meta.env.VITE_WS_URL as string | undefined,
): string {
  const configured = (override ?? "").trim();
  if (configured) {
    return configured.replace(/\/+$/, "");
  }
  return `${location.protocol === "https:" ? "wss:" : "ws:"}//${location.host}`;
}
